import { createFileRoute, redirect } from '@tanstack/react-router'
import { Layout } from '@/shared/components/Layout'
import { useAuthStore } from '@/shared/store/authStore'
import { JiraToolbeltTabs } from '@/features/jira-toolbelt/components/JiraToolbeltTabs'

function JiraToolbeltPage() {
  return (
    <Layout>
      <div className="mx-auto max-w-5xl p-6 space-y-6">
        <div>
          <h1 className="text-2xl font-bold tracking-tight">Jira Toolbelt</h1>
          <p className="text-muted-foreground text-sm mt-1">
            AI-powered tools for Jira stories, PRs, and more
          </p>
        </div>

        <JiraToolbeltTabs />
      </div>
    </Layout>
  )
}

export const Route = createFileRoute('/dashboard/jira-toolbelt')({
  beforeLoad: () => {
    const { session, loading } = useAuthStore.getState()
    if (!loading && !session) {
      throw redirect({ to: '/login' })
    }
  },
  component: JiraToolbeltPage,
})
